import { Alert } from "@mantine/core";
import classes from "./FormAlert.module.css";

export interface FormAlertProps {
  title: string;
  message?: string;
}

/** Маягтын дээд хэсгийн алдаа (toast биш). */
export function FormAlert({ title, message }: FormAlertProps) {
  return (
    <Alert
      color="red"
      variant="light"
      role="alert"
      title={title}
      classNames={{ root: classes.root, title: classes.title, message: classes.message }}
    >
      {message}
    </Alert>
  );
}
